import get from 'lodash/get';
import { createSelector, createStructuredSelector } from 'reselect';
import { userPlanHolderSelector, userSubscriptionSelector } from 'src/selectors/user';
import {
  LEGACY_PLAN,
  SMART_HOME_PLAN,
  NO_PLAN,
} from 'src/containers/AddSkuPage/QuestionsFlowPage/constants';
import { pureCartSelector } from 'src/selectors/cart';

const planTypeSelector = createSelector(
  [userPlanHolderSelector, userSubscriptionSelector],
  (hasAPlan, isSmartHomeSubscriber) => {
    if (isSmartHomeSubscriber) {
      return SMART_HOME_PLAN;
    }
    if (hasAPlan && !isSmartHomeSubscriber) {
      return LEGACY_PLAN;
    }
    return NO_PLAN;
  },
);

const remotePossibleSelector = createSelector(
  [pureCartSelector],
  (cart) => get(cart, 'remotePossible', false)
);

export default createStructuredSelector({
  planType: planTypeSelector,
  remotePossible: remotePossibleSelector,
});
